import Container from "../components/Container";
import Show from "../components/Show";
import Text from "../components/Text";
import ProcessingAssetsBanner from "../components/ProcessingAssetsBanner";

interface IPageProps {
    title?: string;
    children: React.ReactNode;
    subTitle?: string;
}

export default function Page({ title, children, subTitle }: IPageProps) {
    return (
        <Container fullWidth flexColumn padding="3" className="pb-8 md:pb-3" relative>
            <Show when={!!title}>
                <Text size="xl" color="600" fontWeight="semibold">{title}</Text>
            </Show>

            <Show when={!!subTitle}>
                <Text size="sm" color="400" fontWeight="semibold">{subTitle}</Text>
            </Show>

            <Container fullWidth flexColumn className={`${!!title ? "mt-5" : ""}`}>
                <ProcessingAssetsBanner />
                {children}
            </Container>
        </Container>
    );
}